<script setup>
import { inject, nextTick, ref, watch } from 'vue';

const overlay = ref(null)
const draftText = inject('draftText')
watch(draftText, async () => {
  await nextTick()
  if (overlay.value) {
    overlay.value.scrollTop = overlay.value.scrollHeight
  }
})

</script>

<template>
  <div ref="overlay" class="overlay">
    <div class="prose prose-md md:prose-sm bg-base-100" >
      <div v-html="draftText" />
    </div>    
  </div>
</template>

<style lang="less">

  .overlay {
    overflow-y: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    padding: var(--editor-content-paddings);  
    border-radius: 0 0 var(--editor-border-border-radius) var(--editor-border-border-radius);
  }


</style>